<template>
	<div class="wrap">
		<el-select
			v-model="stockCodes"
			placeholder="代码或名称"
			style="width: 100%;"
			filterable
			clearable
			multiple
			remote
			:remote-method="remoteMethod"
			@change="val => changeCode(val)"
			@visible-change="visibleChange"
			class="mb"
			:loading="searchLoading"
		>
			<el-option
				v-for="(item, index) in elSelect103Options"
				:key="index"
				:label="item.label"
				:value="item.value"
			/>
		</el-select>

		<div class='mb'>
			<el-radio
				v-model="onlyTradingDay"
				:label="1"
				@change="changeType"
			>只显示交易日</el-radio>
			<el-radio
				v-model="onlyTradingDay"
				@change="changeType"
				:label="2"
			>显示全部日期</el-radio>
		</div>
		<el-checkbox-group
			v-model="dataType"
			size="mini"
			class="mb"
		>
			<el-checkbox
				style="width: 140px;margin-right: 0;"
				v-for="(item, idx) in dateListShow"
				:key="idx"
				:label="item.date"
			>{{ item.date }}</el-checkbox>
		</el-checkbox-group>

		<el-button
			type="primary"
			size="mini"
			plain
			class="mb"
			@click="reset"
		>重置</el-button>
		<!-- <el-button
			type="primary"
			size="mini"
			plain
			class="mb"
			@click="changeActive()"
		>全选</el-button> -->

		<el-button
			type="primary"
			size="mini"
			plain
			class="mb"
			@click="submitForm"
			:loading="isFetching"
			:disabled="isFetching"
		>{{ isFetching ? '查询中' : '查询' }}</el-button>

		<el-table
			ref="table"
			:data="tableData"
			:border="true"
			style="width: 100%; margin-bottom: 10px;"
			:header-cell-style="{color:'#292d39'}"
			class="mb data-table"
		>
			<el-table-column
				align="center"
				min-width="100"
				label="名称"
			>
				<template slot-scope="scope">
					<div>
						{{ scope.row.stockName }}
						<br>
						{{ scope.row.code }}
					</div>
				</template>
			</el-table-column>
			<el-table-column
				align="center"
				min-width="200"
				label="帖子"
			>
				<template slot-scope="scope">
					<div>
						<p v-for="(val, key) in scope.row.guba" :key='key'>
							<span>{{ key }}:</span><span style="width: 25%; display: inline-block;">{{ val.count }}</span>
						</p>
					</div>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
import axios from 'axios'
import dayjs from 'dayjs'
import pLimit from 'p-limit' // 使用 p-limit 库来控制并发数量
const limit = pLimit(5) // 设置并发限制为 5 个请求
// 创建任务列表的辅助函数
function createTaskList(list, handler) {
  return list.map(target =>
    limit(async() => {
      try {
        await handler(target);
      } catch (error) {
        console.log('error.message===>', error.message);
      }
    })
  );
}
export default {
	components: {
	},
	data() {
		return {
      holidays: {},
			dataType: [],
      dateList: [],
      tableData: [],
      stockCodes: JSON.parse(localStorage.getItem('stockCodes')) || [],
			elSelect103Options: [],
			onlyTradingDay: 1,
			isFetching: false, // 防止重复查询
			searchLoading: false, // 防止重复查询
		}
	},
	computed: {
		isPopup() {
			return this.chrome && this.chrome.runtime
		},
		dateListShow() {
			return this.dateList.filter(item => {
				if (this.onlyTradingDay === 1) {
					return item.isTradingDay
				} else {
					return true
				}
			})
		}
	},
	watch: {
		stockCodes: {
			handler(val) {
				localStorage.setItem('stockCodes', JSON.stringify(val || []))
			},
		},
	},
  async created() {
		await this.getHolidays();
		await this.init();
  },
  mounted() {
  },
  methods: {
		changeType(t) {
			if (t == 1) {
				this.dataType = this.dateListShow.filter(item => this.dataType.includes(item.date)).map(item => item.date);
			}
		},
		reset() {
			this.dataType = [];
		},
		changeActive() {
			this.dataType = this.dateListShow.map(item => item.date);
		},
		async init() {
      this.dateList = this.getTradingDays()
    },
    getTradingDays(targetLength = 15) {
      const res = []
      let date = dayjs(dayjs().format('YYYYMMDD'))

      while (res.length < targetLength) {
        const dateStr = date.format('YYYY-MM-DD');
				const info = {
					date: dateStr,
					isTradingDay: this.isTradingDay(dateStr)
				}
				res.push(info)
        date = date.subtract(1, 'day') // Move to the previous day if not a trading day
      }
      return res
    },
    isTradingDay(dateStr) {
      dateStr = dateStr || dayjs().format('YYYYMMDD')
      const date = dayjs(dateStr)
      const formattedDate = date.format('YYYYMMDD')

      // 判断是否为周六或周日
      const isWeekend = date.day() === 0 || date.day() === 6

      // 判断是否为节假日
      const isHoliday = this.holidays[formattedDate] !== undefined

      const isTrading = !isWeekend && !isHoliday
      return isTrading
    },
		async calcCount(code, targetDays = []) {
			let page = 1;
			const res = {};
			// Sort targetDays to ensure we're processing in reverse chronological order
			const sortedTargetDays = targetDays.sort((a, b) => dayjs(b).isBefore(dayjs(a)) ? 1 : -1);
			// console.log('sortedTargetDays===>', sortedTargetDays)
			if (!sortedTargetDays.length) {
				return res;
			}

			while (true) {
				const list = await this.getGubaCount(code, page++);
				if (list.length === 0) {
					break; // 终止循环
				}
				// 1: 资讯 2: 研报  3: 公告  11: 问董秘
				for (const { post_publish_time, user_id } of list.filter(el => ![1, 2, 3, 11].includes(el.post_type))) {
					const postDay = post_publish_time.slice(0, 10);

					if (sortedTargetDays[0] > postDay) {
						return res;
					} else {
						if (sortedTargetDays.includes(postDay)) {
							res[postDay] = res[postDay] || { users: new Set(), count: 0 };

							if (!res[postDay].users.has(user_id)) {
								res[postDay].users.add(user_id);
								res[postDay].count = res[postDay].count + 1;
							}
						}
					}
				}
			}

			return res;
		},
		visibleChange() {},
		async getHolidays() {
      // 解析 iCalendar 数据，并提取节假日信息
      function parseICalendar(data) {
        const events = data.match(/BEGIN:VEVENT([\s\S]*?)END:VEVENT/g)
        if (events) {
          events.forEach(event => {
            const dtStart = event.match(/DTSTART;VALUE=DATE:(\d{8})/)
            const dtEnd = event.match(/DTEND;VALUE=DATE:(\d{8})/)
            const summaryMatch = event.match(/SUMMARY;LANGUAGE=zh_CN:(.*)/)

            if (dtStart && summaryMatch && dtEnd) {
              let currentDate = dayjs(dtStart[1])
              const endDate = dayjs(dayjs(dtEnd[1]).subtract(1, 'day').format('YYYYMMDD'))
              // 在遍历日期时，包含最后一天
              while (currentDate.isBefore(endDate) || currentDate.isSame(endDate)) {
                // 将当前日期转成 YYYYMMDD 格式并添加到数组中
                this.holidays[currentDate.format('YYYYMMDD')] = summaryMatch[1]
                currentDate = currentDate.add(1, 'day')
              }
            }
          })
        }
      }

      // 判断某个日期是否为交易日（非周末且非节假日）
			const res = await axios.post('https://api.amazingxia.top/proxy', {
				url: 'https://calendars.icloud.com/holidays/cn_zh.ics'
			})
      const calendars = res.data
      parseICalendar.call(this, calendars)
    },

		customSortMethod(a, b) {
      return a.active === b.active ? 0 : a.active ? -1 : 1 // 让 `true` 排在 `false` 之前
    },
    async submitForm() {
			if (this.dataType.length === 0) {
				this.$message.error('请选择日期')
				return
			}
			if (this.stockCodes.length === 0) {
				this.$message.error('请选择股票')
				return
			}
			if (this.isFetching) return; // 避免重复查询
			this.isFetching = true;
			this.tableData = [];
			try {
				const tasks = [
					...createTaskList(this.stockCodes, async(target) => {
						const code = target.split(':')[0]
						const name = target.split(':')[1]

						const guBa = await this.calcCount(code, this.dataType);
						this.tableData.push({
							stockName: name,
							guba: guBa,
							code: code
						})
					})
				];
				// 执行所有任务
				await Promise.all(tasks);
			} catch (error) {
				this.$message.error('查询失败')
			}
			this.isFetching = false;
    },

		async getGubaCount(code = '301366', time = 1) {
			// 一次请求2页数据
			const N = 2;
			const startPage = (time - 1) * N + 1;
			const endPage = time * N;
			const requests = [];
			for (let i = startPage; i <= endPage; i++) {
				requests.push(axios.post('https://api.amazingxia.top/proxy', {
					url: `https://gbapi.eastmoney.com/webarticlelist/api/Article/WebArticleList?code=${code}&p=${i}&ps=100&sorttype=0&plat=wap&version=300&product=guba&deviceid=1`,
				}));
			}

			const responses = await Promise.all(requests);
			const list = responses.flatMap(res => res.data.re || [])
			const res = list.map(({post_type, post_publish_time, post_user }) => {
				return {
					post_type,
					post_publish_time,
					user_id: post_user.user_id
				}
			})
			// console.log('res===>', res)
			return res;
		},

		changeCode(code) {
			if (!code) {
				this.elSelect103Options = []
			}

			this.$nextTick(() => {
				this.elSelect103Options = []
			})
		},

		async remoteMethod(query) {
      if (query !== '') {
				this.searchLoading = true;
        const res = await axios.post('https://api.amazingxia.top/proxy', {
          url: `https://search-codetable.eastmoney.com/codetable/search/web/wap?label=&keyword=${query}&pageIndex=1&pageSize=20&client=wap&clientType=wapSearch&clientVersion=lastest&_=${Date.now()}`,
        })
        const list = res.data.result.quoteList || []
        this.elSelect103Options = list.map(item => {
					const label = item.shortName.replace(/<\/?em>/g, '');
					const val = `${item.code}`.replace(/<\/?em>/g, '')
          return {
            label: `${val}:${label}`,
            // value: item.market + '.' + `${item.code}`.replace(/<\/?em>/g, '')
            value: `${val}:${label}`
          }
        })
				this.searchLoading = false;
      } else {
        this.elSelect103Options = [];
				this.searchLoading = false;
      }
    },
  }
}
</script>
<style>
* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
}
.wrap {
	width: 320px;
	margin: 0 auto;
	padding: 30px 0;
}
.mb {
	margin-bottom: 10px !important;
}
.mr {
	margin-right: 10px !important;
}
.el-table .cell, .el-table--border td:first-child .cell {
	padding: 0 !important;
	text-align: center;
}
.el-table td, .el-table th {
	padding: 0 !important;
}
.data-table  .el-input-number {
	width: 100% !important;
	display: inline-block;
}
.el-input-number.is-controls-right .el-input__inner {
	padding: 3px 30px 3px 0px !important;
}

.alert {
	cursor: pointer;
}
.active {
	color: cornflowerblue;
}

.el-tag107 {
  margin: 0 11px 0 0;
}

.el-checkbox-group104 {
  margin: 0 0 0 9px;
}

</style>

<style>
html {
}
html, .el-table {
	/* background: #c5ffe5 !important;
	background: linear-gradient(to bottom, #c5ffe5, #bcffff); */
}
.bold {
	font-weight: bold;
}

.red {
	color: #dc143c;
}
.green {
	color: #69c16e;
}

#C1 .g2-tooltip {
	left: -600px !important;
  top: -240px !important;
}

#C3 .g2-tooltip {
	left: -600px !important;
}

.tooltip-item {
	flex: none;
	/* width: max-content; */
	overflow: hidden;
	white-space: nowrap;
}

.cyb .el-table .caret-wrapper {
	display: inline-flex;
	flex-direction: column;
	align-items: center;
	height: 34px;
	width: 10px;
	vertical-align: middle;
	cursor: pointer;
	overflow: initial;
	position: relative;
}

.auto .el-tag--small {
	padding: 0;
	display: inline-flex;
	justify-content: space-between;
	align-items: center;
}

.auto .el-tag--small span {
	flex: 1;
	width: 79px;
	overflow: hidden;
}

.auto .el-tag--small .el-icon-close {
	flex: none;
	transform: scale(1);
	font-size: 16px;
	right: 0;
}

.new-item {
	background: #fcf6ed;
}

.flex {
	display: flex;
	justify-content: center;
	align-items: center;
}

.mini {
	font-size: 12px;
	line-height: 1;
}

.ml {
	margin-left: 10px;
}

.icon-rz {
	color: #458ad9;
	display: inline-block;
	padding: 0 0.2px;
	border-radius: 0.1px;
	transform: scale(0.8);
	line-height: 0.9;
}

.star-icon {
	color: #458ad9;
	font-size: 22px;
	cursor: pointer;
}

.icon {
	font-size: 12px;
	cursor: pointer;
}

.div104 {
	font-size: 12px;
}

.cyb {
	display: flex;
	padding-bottom: 40px;
	font-size: 14px;
	padding-left: 6px;
  min-height: 100vh;
  overflow-x: auto;
}

.el-table__body tr.current-row>td {
	background-color: #d5e4f7 !important;
}

.setter .el-checkbox {
	font-size: 12px !important;
	font-weight: 400 !important;
	color: #222222 !important;
	padding: 0 !important;
	margin-right: 6px;
}

.setter .el-radio {
	font-size: 12px !important;
	font-weight: 400 !important;
	color: #222222 !important;
	padding: 0 !important;
	margin-right: 6px;
}

.setter .el-radio__label {
	font-size: 12px;
	padding-left: 0px;
}

.setter .el-checkbox__label {
	font-size: 12px !important;
	font-weight: 400 !important;
	padding: 0 !important;
	color: #222222 !important;
}

.cyb .el-table .sort-caret {
	width: 0;
	height: 0;
	border: 5px solid transparent;
	position: absolute;
	left: 0px;
}

.cyb .el-table .sort-caret.ascending {
	/* border: 8px solid transparent;
	border-bottom-color: #C0C4CC;
	top: -1px;
	left: 6px; */
}

.cyb .el-table .sort-caret.descending {
	/* border: 8px solid transparent;
	border-top-color: #C0C4CC;
	bottom: -1px;
	left: 6px; */
}

.el-table th>.cell {
	padding: 0;
	min-width: 0;
	box-sizing: border-box;
	text-align: center;
	font-size: 14px;
	font-weight: 700;
}

.right-part {
	flex: 1;
	padding: 12px;
	/* height: calc(100vh - 41px); */
}

.chart-box2 {
	/* background: #0d0d0d; */
	/* margin-bottom: 30px; */
	/* width: min-content; */
	/* margin-left: 20px; */
	/* min-height: 260px;
	min-width: 210px; */
	/* border: 1px solid #C0C4CC; */
}

.store-select {
  width: 66px;
}
.store-select .el-input--mini .el-input__inner {
  padding: 0;
  line-height: 24px;
  height: 24px;
}
.store-select .el-input__suffix {
  display: none;
}
.el-slider__runway {
  margin: 3px 0 !important;
}
</style>
